export const GAME_HEIGHT = 480;
/**
 * height of the game, can be captured
 */
export const GAME_WIDTH = 640;

export const MIDDLE_WIDTH = 640 / 2;
